class SendForm extends HTMLElement {
  connectedCallback() {
    let $button = this.querySelector('#notify-me-button');
    const $email  = this.querySelector('#notify-me-email');
    const $form   = this.querySelector('.notify-form');
    const $container = this.querySelector('.notifyme-form'); 
    const $product = this.querySelector('#notify-me-product');
    const $productId = this.querySelector('#notify-me-product-id');
    const $productImage = this.querySelector('#notify-me-product-image');
    
    $button.addEventListener('click', (e) => {
      e.preventDefault();
      if($email.value != '') {
        $email.classList.remove('error');
        sendForm();
      } else {        
		$email.classList.add('error');  
      }
    });

    const sendForm = async () => {      
      const form = new FormData($form);
      //--    

      const accMessage = $container.querySelector('.account-message')      
      if(accMessage) accMessage.remove()                             
      
      $button.classList.add('active');
      $button.setAttribute('disabled', true);        
      $button.innerHTML = '<i class="fa-icon fa-spinner fa-spin"></i>'
      
      const response = await fetch('https://notificaciones.distritomax.com/api/v1/add-client', {        
        method: 'post',
        body: form            
      })
      .then((res) => res.json())             
      .then((res) => {     
        if(res.status === 'success') {
          const successDiv = document.createElement('div')
          
          successDiv.classList.add('account-message', 'message--success')
          
          successDiv.innerHTML = `<p>${res.message}</p>`                              
          $container.append(successDiv);                    
        } else {
          const errors = res.message;
        
          const errorsShow = document.createElement('div')          
          let ul = "<ul>"
          
          errorsShow.classList.add('account-message', 'message--error')          

          if(typeof errors === 'string') {            
            ul += `<li>${errors}</li>`
          } else {
            for(const error in errors) {
              for(var i=0; i < errors[error].length; i++) {
                if(errors[error][i] != '') {
                  ul += `<li>${errors[error][i]}</li>`                  
                }		 
              }
            }
          }
          
          ul += "</ul>"                    
          errorsShow.innerHTML = `<div class="errors">${ul}</div>`                    
          
          $container.append(errorsShow);
        }        
      })
      .catch((error) => {
        console.log(error);
      })   
      .then(() => {
        $button.classList.remove('active');
        $button.removeAttribute('disabled');
        $button.innerHTML = 'Enviar';
      })
    }
  }
};
customElements.define("send-form", SendForm);